export default (namespace) => ({
  [`${namespace}.total`]: 'Total',
  [`${namespace}.month`]: '{value} / Mes',
  [`${namespace}.continent`]: 'Continente: {value}',
  [`${namespace}.content`]: 'Contenido: {value}',
  [`${namespace}.contract`]: 'Contratar',
  [`${namespace}.excess`]: 'Franquicia: {value}',
});
